module.exports = "<div class=\"container-outer-box\">\n\t\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-lg-9 col-md-12\"> \n        <app-forum [options]=formoption></app-forum>\t    \n      </div>\n      <div class=\"col-lg-3 col-md-12\">\t\t\t\t\t\n        <app-right-sidebar2></app-right-sidebar2>\n      </div>\n    </div>\t\n  \n  </div>\n\n"


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/otopicdetail/otopicdetail.component.html
// module id = ../../../../../src/app/home/otopicdetail/otopicdetail.component.html
// module chunks = common